export default __webpack_public_path__ + "static/media/templates.dcfec8ed.svg";